import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

// import required modules
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// Define the type for carousel items (matching the structure in App.tsx)
type CarouselItem = {
    image: string;
    title: string;
    description: string;
    link: string;
};

type ServicesCarouselProps = {
    items: CarouselItem[];
};

function ServicesCarousel({ items }: ServicesCarouselProps) {
    return (
        <div className="container mx-auto px-6">
            <Swiper
                modules={[Pagination, Navigation, Autoplay]} // Add modules here
                spaceBetween={30}
                slidesPerView={1} // Show 1 slide on mobile initially
                loop={true}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: true,
                }}
                pagination={{
                    type: 'progressbar',
                    clickable: true,
                }}
                navigation={{
                    // Custom button styling can be done via CSS or specific elements
                    // Example using CSS selectors:
                    // .swiper-button-next, .swiper-button-prev { color: #5DA649 !important; }
                    // .swiper-button-next:after, .swiper-button-prev:after { font-size: 24px !important; }
                }}
                breakpoints={{
                    // when window width is >= 768px (md)
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    },
                    // when window width is >= 1024px (lg)
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 50
                    }
                }}
                className="mySwiper" // Add a class for potential custom styling
            >
                {items.map((item, index) => (
                    <SwiperSlide key={index} className="rounded-lg overflow-hidden shadow-lg">
                        <a 
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block cursor-pointer transition-transform duration-300 hover:scale-105"
                        >
                            <div className="relative h-64 md:h-80"> {/* Fixed height container */}
                                <img 
                                    src={item.image} 
                                    alt={item.title} 
                                    className="absolute inset-0 w-full h-full object-cover" 
                                />
                                {/* Overlay */}
                                <div className="absolute inset-0 bg-gradient-to-t from-salus-azul-escuro/80 via-salus-azul-escuro/50 to-transparent"></div>
                                {/* Text Content */}
                                <div className="absolute bottom-0 left-0 p-6 text-salus-branco">
                                    <h3 className="text-xl lg:text-2xl font-bold font-heading mb-2">{item.title}</h3>
                                    <p className="text-sm text-salus-branco-secundario opacity-90">{item.description}</p>
                                </div>
                            </div>
                        </a>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

export default ServicesCarousel;